webpackJsonp([35783957827783],{

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(63);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'article',
	      { id: 'summary-about' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Web Architect'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Design/Architect web solutions for modern web applications'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Usability'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'Expert'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Simple and functional user experiences. (UI / UX)'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Code'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'Engineer'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Semantic, well-structured and efficient code. (Front-end and Back-end)'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'WebOps'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'Engineer'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Reliable, scalable and secure platform with automated code integration/deployment.'
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { id: 'featured-portfolio' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Recent Work'
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Work Title'
	          )
	        ),
	        _react2.default.createElement('img', { src: '', alt: 'work title' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'description' },
	          'Lorem ipsum dolor sit amet, repudiare euripidis cu vis, ei nec dicta animal. Ad utroque mediocritatem ius, sed primis detracto cu. Nec cu eius pericula ocurreret, quo ei putent officiis mediocritatem.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { id: 'latest-blog' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Latest Post'
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Blog post title'
	          )
	        ),
	        _react2.default.createElement('img', { src: '', alt: 'blog post title' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'description' },
	          'Duo stet debitis ad, partem aliquando conclusionemque sed in. Qui offendit appareat petentium cu, vis no aeque persius.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { id: 'direct-contact' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Let\'s Chat'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'click to copy my email address to your clipboard'
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-fb05fafa2af50ce847b9.js